// extracted by mini-css-extract-plugin
export var printerCard = "_gu-1";
export var printerCardConfigured = "_gu-2";
export var printerCardError = "_gu-3";
export var printerCardsContainer = "_gu-0";
export var printerIcon = "_gu-8";
export var printerIconConfigured = "_gu-5";
export var printerIconContainer = "_gu-4";
export var printerIconError = "_gu-6";
export var printerIconUnconfigured = "_gu-7";
export var workstationsTableCard = "_gu-9";